var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFireStreak = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 15,
    y1: 29.33,
    x2: 15,
    y2: 0.67,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ed2424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#f04b27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#f15a29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#f47730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#f79037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f9a23c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#faac3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#fbb040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9ed32"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M25.79,11c.04-.21-.03-.43-.2-.56-.17-.13-.39-.16-.59-.07-1.7,.77-2.87,2.2-3.6,3.42-.43-2.27-1.72-4.38-2.39-5.36-.38-.55-.6-1.1-.67-1.61-.28-2.28,.99-5.33,1-5.36,.09-.21,.04-.46-.12-.62s-.41-.21-.62-.12c-7.14,3.09-10.56,7.46-10.4,13.33-.54-1.27-.81-2.89-.88-3.64-.03-.26-.22-.46-.47-.5-.26-.05-.5,.09-.61,.33-2.24,4.94-2.62,9.22-1.14,12.71,1.84,4.34,5.86,5.83,6.03,5.89,.22,.08,.47,.01,.62-.16,.15-.18,.18-.43,.07-.64-.02-.04-2.08-4-.32-6.91,.7-1.17,1.27-1.95,1.73-2.58,1.02-1.41,1.6-2.21,2.08-4.91,2.83,4.5,.59,10.35,.57,10.42-.08,.19-.04,.41,.09,.56,.13,.16,.33,.24,.53,.21,1.1-.18,1.91-1.73,2.35-2.84,.59,.95,.84,1.9,.74,2.84-.23,2.07-2.09,3.49-2.1,3.5-.23,.17-.29,.48-.16,.73,.1,.19,.3,.3,.5,.3,.06,0,.13-.01,.2-.04,8.24-3.04,7.25-10.98,7.24-11.03-.27-3.26,.55-7.23,.55-7.27Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFireStreak, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Fire_Streak.6b55d128.svg";
export { ForwardRef as ReactComponent };